import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { svgSprite } from '../../../../../hybrid/wrappers';
import InputItem from '../InputItem/InputItem';
import FormSelect from '../../form-dropdown/FormDropdown/FormDropdown';
import FormCheckbox from '../../form-checkbox/FormCheckbox/FormCheckbox';
import { t } from '../../../../../common/components/T';
import { useWidgetTranslates } from '../../../../../common/utils/utils';
import css from './FormProductPrices.module.scss';
import classnames from 'classnames';

const FormProductPrices = ({
    attribute,
    required,
    disabled,
    handlers = {},
    value,
    setFormData,
    errors,
    options,
    currencies,
    marketing_currencies,
    defaultDataCurrency,
    formData
}) => {
    const [dataCurrency, setDataCurrency] = useState(defaultDataCurrency);
    const [mark, setMark] = useState(value && value.length > 0 && value[0].marketing_currency_id ? '0' : '1');
    const isUsingMarketing = useMemo(() => (formData?.is_not_marketing ? '0' : '1'), [formData?.is_not_marketing]);
    const transl = useWidgetTranslates('form');

    const setMarkData = (attr, v) => {
        if (v === '0') {
            setFormData(
                attribute,
                value.map((item) => ({
                    ...item,
                    marketing_currency_id: dataCurrency?.marketing_currency.value
                }))
            );
        } else {
            setFormData(
                attribute,
                value.map((item) => {
                    const accum = {};
                    Object.keys(item).forEach((key) => {
                        if (key !== 'marketing_currency_id' && key !== 'scores_for_client') {
                            accum[key] = item[key];
                        }
                    });
                    return accum;
                })
            );
        }
        setMark(v);
    };
    const [disable, setDisable] = useState(false);
    const filterError = {};
    for (let key in errors) {
        const item = key.includes('prices');
        if (item) {
            filterError[key] = errors[key];
        }
    }
    let errorPrices = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
    for (let key in filterError) {
        const id = Number(key.substring(7, 8));
        const value = key.substring(9);
        errorPrices[id][value] = filterError[key];
    }
    const addDiapason = () => {
        if (value.length > 10) {
            setDisable(true);
        } else {
            if (mark === '1') {
                setFormData(attribute, [
                    ...value,
                    {
                        currency_id: dataCurrency?.currency.value,
                        product_count_from: '1',
                        price_for_client: '',
                        price_for_partner: ''
                    }
                ]);
            } else if (mark === '0') {
                setFormData(attribute, [
                    ...value,
                    {
                        currency_id: dataCurrency?.currency.value,
                        marketing_currency_id: dataCurrency?.marketing_currency.value,
                        product_count_from: '1',
                        price_for_client: '',
                        scores_for_client: '',
                        price_for_partner: ''
                    }
                ]);
            }
        }
    };
    const deleteDiapason = (idx, mark) => {
        if (mark) {
            const oldArr = value.filter((el) => el.currency_id !== dataCurrency?.currency.value);
            const newArr = value
                .filter((el) => el.currency_id === dataCurrency?.currency.value)
                .filter((el) => el.marketing_currency_id === dataCurrency?.marketing_currency.value);
            newArr.splice(idx, 1);
            setFormData(attribute, [...oldArr, ...newArr]);
        } else {
            const oldArr = value.filter((el) => el.currency_id !== dataCurrency?.currency.value);
            let newArr = value.filter((el) => el.currency_id === dataCurrency?.currency.value);
            newArr.splice(idx, 1);
            setFormData(attribute, [...oldArr, ...newArr]);
        }
    };
    let modernOptions = [];
    if (mark === '0') {
        modernOptions = options;
    } else {
        options.map((opt) => {
            if (opt.alias === 'product_count_from' || opt.alias === 'price_for_client' || opt.alias === 'price_for_partner') {
                modernOptions.push(opt);
            }
        });
    }

    return (
        <div>
            <div className={css.formProductPricesHeaderWrapper}>
                <div className={css.formProductPricesHeaderItem}>
                    <FormSelect
                        compStyle={{
                            wrapper: {
                                className: css.formProductPricesWrapper,
                                justifyContent: 'flex-start !important'
                            }
                        }}
                        type='dropdown'
                        attribute='currency_id'
                        default_value='1'
                        disabled={false}
                        hint={null}
                        options={currencies || []}
                        noTranslate={true}
                        placeholder={t('form-ChooseCurrency', 'Выберите валюту', 'widget', transl, 'form')}
                        required={false}
                        title={{
                            body: t('form-currency', 'Валюта', 'widget', transl, 'form')
                        }}
                        setFormData={setFormData}
                        handlers={{
                            onChange: (e) => {
                                setDataCurrency({
                                    ...dataCurrency,
                                    currency: e
                                });
                            }
                        }}
                        errors={errors['prices']}
                        value={dataCurrency?.currency}
                    />
                </div>
                {isUsingMarketing === '1' ? (
                    <div>
                        <FormSelect
                            compStyle={{
                                wrapper: {
                                    className: css.formProductPricesWrapper,
                                    justifyContent: 'flex-start !important'
                                }
                            }}
                            attribute='marketing_currency_id'
                            type='dropdown'
                            default_value='1'
                            disabled={true}
                            hint={null}
                            options={marketing_currencies || []}
                            placeholder={t(
                                'form-MarketingChooseCurrency',
                                'Выберите маркетинговую валюту',
                                'widget',
                                transl,
                                'form'
                            )}
                            required={false}
                            title={{
                                body: t('form-MarketingCrrency', 'Маркетинговая валюта', 'widget', transl, 'form')
                            }}
                            setFormData={setFormData}
                            handlers={{
                                onChange: (e) =>
                                    setDataCurrency({
                                        ...dataCurrency,
                                        marketing_currency: e
                                    })
                            }}
                            errors={mark === '0' ? errors['prices'] : false}
                            isClear={false}
                            value={dataCurrency?.marketing_currency}
                        />
                    </div>
                ) : null}
                {isUsingMarketing === '1' ? (
                    <div>
                        <FormCheckbox
                            compStyle={{
                                wrapper: { className: css.formProductPricesWrapper }
                            }}
                            attribute='mark_check'
                            type='checkbox'
                            disabled={defaultDataCurrency?.marketing_currency?.value == undefined}
                            hint={null}
                            required={true}
                            title={{
                                body: t(
                                    'form-MarketingPrice',
                                    'Маркетинговая стоимость не используется для этого товара',
                                    'widget',
                                    transl,
                                    'form'
                                )
                            }}
                            setFormData={setMarkData}
                            handlers={{}}
                            value={mark}
                        />
                    </div>
                ) : null}
            </div>
            <div className={classnames(css.formProductPrices)}>
                {/* Web */}
                <div className={classnames(css.formProductPricesColTabs)}>
                    {modernOptions.map((option, idx) => {
                        return (
                            <div className={classnames(css.formProductPricesColTabsItem)} key={`option${idx}`}>
                                {option.title}
                            </div>
                        );
                    })}
                </div>
                {value && dataCurrency?.currency && mark === '1' ? (
                    value
                        .filter((e) => e.currency_id === dataCurrency?.currency.value)
                        .map((item, index) => (
                            <div key={`item${index}`} className={classnames(css.formProductPricesCol)}>
                                {!!index && (
                                    <div className={css.formProductPricesColClose} onClick={() => deleteDiapason(index)}>
                                        {svgSprite('cross', {
                                            className: css.formCheckboxSvg
                                        })}
                                    </div>
                                )}
                                {modernOptions.map((option, idx) => {
                                    return (
                                        <InputItem
                                            value={value}
                                            key={`optionss${idx}`}
                                            attribute={attribute}
                                            setFormData={setFormData}
                                            handlers={handlers}
                                            required={required}
                                            disabled={disabled}
                                            errors={
                                                Object.keys(errorPrices[index]).length !== 0
                                                    ? errorPrices[index][option.alias]
                                                    : []
                                            }
                                            option={option}
                                            index={index}
                                            idx={idx}
                                            currency={dataCurrency?.currency}
                                            setDataCurrency={setDataCurrency}
                                        />
                                    );
                                })}
                            </div>
                        ))
                ) : value && dataCurrency?.currency && dataCurrency?.marketing_currency ? (
                    value
                        .filter((e) => e.currency_id === dataCurrency?.currency.value)
                        .map((item, index) => (
                            <div key={`item${index}`} className={classnames(css.formProductPricesCol)}>
                                {!!index && (
                                    <div className={css.formProductPricesColClose} onClick={() => deleteDiapason(index, true)}>
                                        {svgSprite('cross', {
                                            className: css.formCheckboxSvg
                                        })}
                                    </div>
                                )}
                                {modernOptions.map((option, idx) => {
                                    return (
                                        <InputItem
                                            value={value}
                                            key={`optionss${idx}`}
                                            attribute={attribute}
                                            setFormData={setFormData}
                                            handlers={handlers}
                                            required={required}
                                            disabled={disabled}
                                            errors={
                                                Object.keys(errorPrices[index]).length !== 0
                                                    ? errorPrices[index][option.alias]
                                                    : []
                                            }
                                            option={option}
                                            index={index}
                                            idx={idx}
                                            currency={dataCurrency?.currency}
                                            setDataCurrency={setDataCurrency}
                                        />
                                    );
                                })}
                            </div>
                        ))
                ) : (
                    <div className={classnames(css.formProductPricesCol)}>
                        {modernOptions.map((option, idx) => {
                            return (
                                <InputItem
                                    value={[]}
                                    key={`optionss${idx}`}
                                    attribute={attribute}
                                    setFormData={setFormData}
                                    handlers={handlers}
                                    required={required}
                                    disabled={true}
                                    option={option}
                                    index={1}
                                    idx={idx}
                                    currency={dataCurrency?.currency}
                                    setDataCurrency={setDataCurrency}
                                />
                            );
                        })}
                    </div>
                )}
                {value && dataCurrency?.currency && mark === '1' ? (
                    <div className={css.formProductPricesAdd} onClick={disable ? () => {} : () => addDiapason()}>
                        {svgSprite('plus', {
                            width: 14,
                            height: 14,
                            fill: 'var(--blueColor)'
                        })}
                    </div>
                ) : value && dataCurrency?.currency && dataCurrency?.marketing_currency ? (
                    <div className={css.formProductPricesAdd} onClick={disable ? () => {} : () => addDiapason()}>
                        {svgSprite('plus', {
                            width: 14,
                            height: 14,
                            fill: 'var(--blueColor)'
                        })}
                    </div>
                ) : (
                    <></>
                )}
            </div>
        </div>
    );
};
FormProductPrices.propTypes = {
    attribute: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    handlers: PropTypes.object,
    value: PropTypes.array,
    setFormData: PropTypes.func,
    errors: PropTypes.array,
    options: PropTypes.array,
    currencies: PropTypes.array,
    marketing_currencies: PropTypes.array,
    defaultDataCurrency: PropTypes.object
};
export default FormProductPrices;
